import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TitleService from 'title-service';
import { useDispatch, useSelector } from 'react-redux';
import { getUserClaims } from 'features/application/application-slice';
import { create_checkout_session } from 'features/auto-thunks';
import CharacterCard from 'ui-component/CharacterCard';
import './SubscribePanel.scss';
import CharacterRow from 'ui-component/CharacterRow';
import { CircularProgress } from '@mui/material';

const SubscribePanel: React.FC = () => {
    const [sessionUrl, setSessionUrl] = useState(null);
    let claims = useSelector(getUserClaims);
    const dispatch = useDispatch();
    useEffect(() => {
        if (claims?.user) {
            dispatch(create_checkout_session({
                userId: claims?.user,
                callback: ((success, response) => {
                    console.log(success)
                    if (success) {
                        console.log(response)
                        setSessionUrl(response.data.url);
                    }
                })
            }))
        }
    }, [claims?.user])
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'auto',
            backgroundImage: 'url(Your-Hero-Background-Image-URL)',
            backgroundSize: 'cover',
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 'auto',
                backgroundImage: 'url(Your-Hero-Background-Image-URL)',
                backgroundSize: 'cover'
            }}>
                <div className='subscribe-card'>
                    <div className='subscribe-card-info '>
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                            <div style={{
                                zIndex: -1
                            }}>
                                <CharacterRow />
                            </div>
                            <div className='subscribe-content'>
                                <h1 className='subscribe-title'>{TitleService(`Discover Endless Fun at Playwatch Kids!`)}</h1>
                                <p className='subscribe-paragraph'>{TitleService(`Enjoy a vast collection of kid-friendly videos for just $2.99. Subscribe today and start your adventure in safe and exciting learning!`)}</p>
                            </div>
                        </div>
                        {sessionUrl ? <Button className='subscribe-button'
                            onClick={() => {
                                window.open(sessionUrl, '_self');
                            }} variant="contained" color="primary">
                            {TitleService('Subscribe')}
                        </Button> : <CircularProgress />}
                    </div>
                </div>
            </Box>
        </Box>
    );
};

export default SubscribePanel;
